<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>교육 신청</p></li>
            <li><p>접수 확인 및 취소</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>접수 확인 및 취소</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl_big">
                    <p>
                      {{ item.edu.title }}
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>종목명</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">외식경영 관리사</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">
                      <span class="color bold">{{
                        item.userEdu.educationCode
                      }}</span>
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육신청</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.rating }}급</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육장소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.edu.eduAddress }}</p>
                  </div>
                </li>
                <li class="form_li top_bo">
                  <div class="form_ttl">
                    <p>이름</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.name }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>생년월일</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.userBirth }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>이메일</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.email }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>장애여부</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">
                      {{
                        item.userEdu.isDisorder === 1
                          ? '해당 없음'
                          : '해당 있음'
                      }}
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>편의요청사항</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.memo }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>주소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.postCode }}</p>
                    <p class="bind">{{ item.userEdu.userAddress }}</p>
                    <p class="bind">{{ item.userEdu.userAddress2 }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>휴대폰 번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.userPhone }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>비상연락처</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userEdu.phone }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn bo grey" @click="() => $router.go(-1)">
            이전으로
          </button>
          <button class="btn" @click="fnModal">교육 취소하기</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-edu-register-view',
  description: '접수 확인 및 취소 상세',
  data: function() {
    const userEducationNo = Number(this.$route.query.userEducationNo)
    return {
      userEducationNo,
      item: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapUserEdu({
        userEducationNo: this.userEducationNo
      })
      this.item = res.entity
    },
    fnModal: function() {
      const now = new Date();
      const year = now.getFullYear()
      let month = (1 + now.getMonth())
      month = month >= 10 ? month : '0' + month
      let day = now.getDate()
      day = day >= 10 ? day : '0' + day
      const currentDate = year + '' + month + '' + day
      console.log(this.item.edu.cancelDate)
      if(this.item.edu.cancelDate < currentDate) {
        alert('취소 가능 일자 지나 취소할 수 없습니다.')
        return;
      }
      // 교육상태가 [교육취소] 일 경우
      if (this.item.userEdu.eduStatus === 3) {
        alert('취소 처리중입니다.')
        return false
      }
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EDU_CANCEL_POPUP,
        data: { examType: 1 },
        callBack: this.fnCancel
      })
    },
    fnCancel: async function(event, form) {
      form.userEducationNo = this.userEducationNo
      const res = await this.$ManagerSvc.patchIntEduCancel(form)
      if (res.code === 1) {
        alert('접수되었습니다.')
        this.$router.go(-1)
      } else {
        alert(res.message)
      }
    }
  }
}
</script>

<style scoped></style>
